import { status } from 'skin/event/status';
import setInput from './setInput'

const data = (obj, ms, story, data, d, action) => {
	switch (obj.action) {
		case 'setInput':
			return setInput(obj, ms, story, data, d, action);
		default:
			return status.action;
	}
};

export default data;